"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blinkOnRunningTimeout = exports.blinkKeyframes = exports.halfOpacityOnPause = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_redux_1 = require("react-redux");
var humanizeTimer_1 = __importDefault(require("./humanizeTimer"));
var usePlayerTime_1 = __importDefault(require("./usePlayerTime"));
function PlayerTimer(_a) {
    var playerId = _a.playerId, _b = _a.customStyle, customStyle = _b === void 0 ? [exports.halfOpacityOnPause, exports.blinkOnRunningTimeout] : _b, props = __rest(_a, ["playerId", "customStyle"]);
    var playing = (0, react_redux_1.useSelector)(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.players.find(function (p) { return p.id === playerId; })) === null || _a === void 0 ? void 0 : _a.time) === null || _b === void 0 ? void 0 : _b.playing) !== null && _c !== void 0 ? _c : false; });
    var playerTime = (0, usePlayerTime_1.default)(playerId);
    if (!playerTime)
        return null;
    return ((0, jsx_runtime_1.jsxs)("span", __assign({}, props, { css: customStyle.map(function (fc) { return fc(playing, playerTime); }) }, { children: [playerTime < 0 && '-', (0, humanizeTimer_1.default)(Math.abs(playerTime))] })));
}
exports.default = PlayerTimer;
var halfOpacityOnPause = function (playing) { return !playing && (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: 0.5;\n"], ["\n  opacity: 0.5;\n"]))); };
exports.halfOpacityOnPause = halfOpacityOnPause;
exports.blinkKeyframes = (0, react_1.keyframes)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  to {\n    visibility: hidden;\n  }\n"], ["\n  to {\n    visibility: hidden;\n  }\n"])));
var blinkOnRunningTimeout = function (playing, timeLeft) { return playing && timeLeft < 0 && (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation: ", " 1s steps(8, start) infinite;\n"], ["\n  animation: ", " 1s steps(8, start) infinite;\n"])), exports.blinkKeyframes); };
exports.blinkOnRunningTimeout = blinkOnRunningTimeout;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=PlayerTimer.js.map